import React from "react";

import { Box, Typography, CircularProgress } from "@mui/material";

import { KeyContactsList } from "../components/key-contacts";
import { MainLayout } from "../components/layout/MainLayout";
import { CACard } from "../components/ui";
import { useServiceAdditionalInfo } from "../hooks";
import { useAppSelector } from "../store/hooks";

export const EscalationPathPage: React.FC = () => {
  const selectedService = useAppSelector((state) => state.service.selectedService);
  const { data: additionalInfo, isLoading: isLoadingAdditionalInfo } = useServiceAdditionalInfo(
    selectedService?.serviceId ?? null,
  );

  if (!selectedService) {
    return (
      <MainLayout>
        <Box py={4}>
          <CACard>
            <Box sx={{ padding: 2 }}>
              <Typography variant="h6" color="textSecondary" align="center">
                Please select a service to view escalation path contacts.
              </Typography>
            </Box>
          </CACard>
        </Box>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <Box sx={{ p: 3 }}>
        <CACard sx={{ mb: 3 }}>
          <Box sx={{ p: 3 }}>
            <Typography variant="h4" component="h1" gutterBottom>
              Your Key Contacts
            </Typography>

            <Box mb={4}>
              {isLoadingAdditionalInfo ? (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <CircularProgress size={20} sx={{ mr: 1 }} />
                  <Typography variant="body1">Loading...</Typography>
                </Box>
              ) : (
                <Typography variant="body1" paragraph>
                  We're committed to supporting all families to balance work and life responsibilities, by delivering
                  exceptional education and care outcomes for students in your Camp Australia Outside School Hours Care
                  (OSHC) program {additionalInfo?.hasUpcomingNationalDayPrograms ? "and Rocketeers programs" : ""}. On
                  this page, you will find your key contacts, from your Relationship Manager, to our Head of Service
                  Delivery. As we value our partnership and appreciate your feedback, should you have any questions,
                  queries or concerns that you wish to raise with us, please do not hesitate to contact one of the
                  listed key contacts at any time convenient for you.
                </Typography>
              )}
            </Box>

            <KeyContactsList serviceId={selectedService.serviceId!} />
          </Box>
        </CACard>
      </Box>
    </MainLayout>
  );
};
